import React from "react";
import { CustomReportListTablePanel } from "#batteries-included-components/Panels/TablePanels/CustomReportListTablePanel";
import { CustomReportVariants } from "#batteries-included-components/Layouts/CustomReport/CustomReportDetailLayout.helpers";
import { CustomReportListFilterPanel } from "#batteries-included-components/Panels/FilterPanels/CustomReportListFilterPanel";
import { useStorageKey } from "#src/hooks/useStorageKey";

export const EmissionCustomReportListTab = ({
  isOldSidebarLocation,
}: {
  isOldSidebarLocation?: boolean;
}) => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "emissions-custom-report-list"
    );

  return (
    <>
      <CustomReportListFilterPanel
        filterConfigStorageKey={filterConfigStorageKey}
      />
      <CustomReportListTablePanel
        variant={CustomReportVariants.EMISSIONS}
        isOldSidebarLocation={isOldSidebarLocation}
        filterConfigStorageKey={filterConfigStorageKey}
        tableConfigStorageKey={tableConfigStorageKey}
        tableStateStorageKey={tableStateStorageKey}
      />
    </>
  );
};
